import styled from '@emotion/styled';
import { themeColors } from 'src/theme';
import { UserStatus as UserStatusEnum } from 'src/shared/enums/userStatus.enum';
import { P3 } from '../Typography';
import { PickEnum } from '../../utils/utils';

const StyledStatus = styled(P3)({
  padding: '0 10px',
  display: 'flex',
  alignItems: 'center',
  textTransform: 'lowercase',
  borderRadius: '4px',
});

export const adminInviteStatusNameByCode = {
  [UserStatusEnum.DEACTIVATED]: 'pending',
  [UserStatusEnum.ACTIVE]: 'active',
};

const colorByStatusCode = {
  [UserStatusEnum.DEACTIVATED]: themeColors.lightYellow,
  [UserStatusEnum.ACTIVE]: themeColors.greenLight,
};

type ClearStatusProps = {
  adminInviteStatus: PickEnum<UserStatusEnum, UserStatusEnum.DEACTIVATED | UserStatusEnum.ACTIVE>;
};

const AdminInviteStatus = ({ adminInviteStatus }: ClearStatusProps) => {
  return <StyledStatus sx={{ backgroundColor: colorByStatusCode[adminInviteStatus] }}>{adminInviteStatusNameByCode[adminInviteStatus]}</StyledStatus>;
};

export default AdminInviteStatus;
